import axios from 'axios';
import { getValidAccessToken, refreshAccessToken } from './authTokens';
import { clearSession } from './authSession';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: window.location.hostname === 'localhost' 
    ? 'http://172.235.245.13/api'
    : '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token to all requests
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getValidAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401) {
      if (!originalRequest) {
        clearSession('Your session expired. Please sign in again.');
        return Promise.reject(error);
      }
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const refreshedToken = await refreshAccessToken();
        if (refreshedToken) {
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${refreshedToken}`;
          return axiosInstance(originalRequest);
        }
      }
      clearSession('Your session expired. Please sign in again.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

